import { MouseEventHandler } from 'react';
import { IoIosArrowDroprightCircle } from 'react-icons/io';
import { Link } from 'react-router-dom';

import { Container } from './styles';

interface ISubmenu {
  path: string;
  title: string;
}
interface AsideButtonProps {
  icon: string | JSX.Element;
  title: string;
  submenu?: ISubmenu[];
  active?: string;
  onClick?: MouseEventHandler<HTMLLIElement>;
}

export const AsideButton: React.FC<AsideButtonProps> = ({
  title,
  icon,
  submenu,
  active,
  onClick,
}) => (
  <Container>
    <li className={`menu ${active ? active : ''}`} onClick={onClick}>
      <div className="aside-button-icon">{icon}</div>
      <p>{title}</p>
      {submenu?.length && (
        <ul className="submenu">
          {submenu.map((sub) => (
            <li key={sub.path}>
              <Link to={sub.path}>
                <IoIosArrowDroprightCircle height={15} />
                {sub.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  </Container>
);
